import axios from "axios";
import BASE_URL from "../../assets/global/url";

// One Profit Distribution with its cutoffs and creator
export const getProfitDistributionById = async (id) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/profit_distribution/getProfitDistributionById`,
      { params: { id } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
